export var LoadlineZoneContent;
(function (LoadlineZoneContent) {
    LoadlineZoneContent["TF"] = "TF";
    LoadlineZoneContent["F"] = "F";
    LoadlineZoneContent["T"] = "T";
    LoadlineZoneContent["S"] = "S";
    LoadlineZoneContent["W"] = "W";
    LoadlineZoneContent["WNA"] = "WNA";
})(LoadlineZoneContent || (LoadlineZoneContent = {}));
//# sourceMappingURL=LoadlineZoneContent.js.map